<template>
  <div data-server-rendered="true" id="__nuxt" class="bannerBox">
    <!---->
    <div id="__layout">
      <div id="body">
        <div class="index_body">
          <div class="head_height">
            <div class="banner_box">
              <div class="banner page_width">
                <div class="ban_top">
                  <div class="logo"></div>
                  <div class="right flex">
                    <div class="no_login" v-if="!loginTrue" @click="loginUp()">
                      登录/注册
                    </div>
                    <!-- <div class="no_loginLeft" @click="myInformation" v-else>
                      <span>我的</span>
                    </div> -->
                    <div class="no_loginRight" v-if="loginTrue">
                      <span class="logout" @click="logout" v-if="loginTrue"
                      >退出</span
                      >
                    </div>
                  </div>
                </div>
                <div class="ban_btn">
                  <div class="btn1" @click="hisShow = true" v-if="!hisShow">
                    我要评估
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bord" v-if="hisShow">
            <div>
              <div class="notice">
                该功能生成有效评估报告，降低验证成本与成果转化风险。
              </div>
              <!--加载中的遮罩-->
              <div v-if="isLoading">
                <div class="loadingGif fade-in">
                  <loading />
                  <!--                  <div style="margin-top: 16px">报告生成中...</div>-->
                  <div style="margin-top: 16px;font-size: 20px">报告生成中...</div>
                  <div style="margin-top: 16px;font-size: 20px">该模型包含数据查询、复杂逻辑推导、界面图形生成，请耐心等待1-2分钟</div>
                </div>
              </div>
              <!-- 填写公司名模块 -->
              <div class="form-row" v-if="!isLoading && !textShow">
                <el-form
                    ref="form"
                    :model="sizeForm"
                    :rules="formRules"
                    label-width="180px"
                    size="mini"
                    class="formClass"
                >
                  <el-form-item label="我们开发一种" prop="achievementName">
                    <el-input
                        v-model="sizeForm.achievementName"
                        placeholder="基于xxx技术核心的xxx成果名称"
                    />
                  </el-form-item>

                  <el-form-item label="核心技术原理是" prop="coreTechnology">
                    <el-input
                        autosize
                        type="textarea"
                        v-model="sizeForm.coreTechnology"
                        placeholder="用1-2句话说xxx技术的原理机制"
                    />
                  </el-form-item>

                  <el-form-item label="技术突破点在于" prop="breakthrough">
                    <el-input
                        autosize
                        type="textarea"
                        v-model="sizeForm.breakthrough"
                        placeholder="对比现有技术有xxx改进"
                    />
                  </el-form-item>

                  <el-form-item label="主要解决" prop="solve">
                    <el-input
                        autosize
                        type="textarea"
                        v-model="sizeForm.solve"
                        placeholder="xxx行业领域的xxx问题"
                    />
                  </el-form-item>

                  <el-form-item label="预计研发投入" prop="investment">
                    <el-input
                        type="number"
                        v-model="sizeForm.investment"
                        placeholder=""
                    >
                      <template #append> 万元 </template>
                    </el-input>
                  </el-form-item>
                </el-form>
                <el-button
                    class="queryButton"
                    type="primary"
                    @click="submitForm"
                    v-if="!textShow"
                >
                  立即评估
                </el-button>
              </div>

              <div id="myapp" v-if="textShow" ref="messageContainer">
                <div class="spanFront">
                  基于您提供的基础信息，AI
                  概念验证中心平台从多个专业维度，给出以下评估报告：
                </div>
                <AdaptiveIframe
                    :src="htmlUrl"
                    custom-class="concept-iframe"
                    :min-height="1000"
                    :height-margin="0"
                    :retry-count="1"
                    :retry-interval="1000"
                    @height-changed="onIframeHeightChanged"
                />
                <!-- <div id="text" class="content" v-html="output"></div> -->
                <div class="btnBox">
                  <button class="refreshPageClass" @click="refreshPage">
                    <span>重新查询</span>
                  </button>
                  <!-- <button class="refreshPageClass" @click="downWorld" v-if="showDown">
                    <span>下载</span>
                  </button> -->
                </div>
              </div>
            </div>
          </div>

          <div class="bord" v-else>
            <div class="notice">历史评估记录</div>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="reportPath" label="历史报告" />
              <el-table-column prop="createTime" label="日期" width="180" />
              <el-table-column label="操作" width="180">
                <template #default="scope">
                  <el-button
                      size="small"
                      type="primary"
                      @click="handleDown(scope.row)"
                  >下载</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px; text-align: center">
              <el-pagination
                  layout="prev, pager, next,total"
                  :total="total"
                  background
                  @current-change="changePage"
              />
            </div>
            <el-empty description="暂无历史数据" v-if="showEmpty">
              <el-button type="primary">我要评估</el-button>
            </el-empty>
          </div>
        </div>
        <!---下面背景图 -->
        <div style="background: #252525">
          <img
              src="../assets/img/c02ddf2d50ba0a9c37c54f6b278d02a.png"
              alt
              class="foot_bg"
          />
          <div class="website">
            <div class="max_wid">
              <div class="max_lef">
                <div class="labe2">
                  通讯地址：泰安市高新区正阳门大街28号国家高创中心西塔422号
                </div>
                <div class="classLabe2">
                  <div class="labe2Left">主办单位：泰山科技大市场</div>
                  <div class="labe2Right">技术支持：0538-8265266</div>
                </div>
              </div>
              <div class="max_rig">
                <!--              <div class="label">服务电话：</div>-->
                <div class="labe2">联系方式：18953878448</div>
                <div class="labe2">邮编：271000</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PersonalInformation from "./PersonalInformation .vue";
import InformationAdmin from "@/views/InformationAdmin.vue";
import PersonalFrom from "@/views/PersonalFrom.vue";
import unionFrom from "@/views/unionFrom.vue";
import HistoricalRecords from "@/views/historicalRecords.vue";
import { getApi, getToken, knowledge } from "@/api/http";
import { getConceptList, getInterfaceSpeed, getHtml } from "@/api/concept";
import test from "@/views/test.vue";
import loading from "@/components/loading.vue";
import AdaptiveIframe from "@/components/AdaptiveIframe.vue";

import axios from "axios";

export default {
  components: {
    HistoricalRecords,
    PersonalFrom,
    unionFrom,
    xinxi: PersonalInformation,
    InformationAdmin,
    test,
    loading,
    AdaptiveIframe,
  },
  data() {
    return {
      htmlUrl: "",
      url: "wss://kejichengguo.tskjdsc.com/WebSocketDocGenerator/WebSocketDocGenerator/message",
      // url: "wss://kejichengguo.tskjdsc.com/websocket/message",
      // url: "ws://localhost:8945/WebSocketDocGenerator/message",
      message: " ",
      text_content: "",
      ws: null,
      sizeForm: {
        achievementName: "", //成果名
        coreTechnology: "", //技术成果
        breakthrough: "", //突破
        solve: "", //解决
        investment: "", //研发投入
      },
      rawData: "", // 用于存储从API获取的完整数据
      parts: [], // 用于逐步显示的数据
      //展示数据
      textShow: false,
      //加载中
      isLoading: false,
      hisShow: true,
      loginTrue: "", //是否登录
      achievementName: "",
      text: "",
      keywords: ["企业概况"],
      output: "",
      token: "",
      pageSize: 10,
      pageNum: 1,
      total: 0,
      showDown: false,
      showDownUrl: "",
      showEmpty: false, // 是否显示空数据
      tableData: [],
      formRules: {
        achievementName: [
          { required: true, message: "请输入成果名称", trigger: "blur" },
        ],
        coreTechnology: [
          { required: true, message: "请输入核心技术原理", trigger: "blur" },
        ],
        breakthrough: [
          { required: true, message: "请输入技术突破点", trigger: "blur" },
        ],
        solve: [
          { required: true, message: "请输入解决的问题", trigger: "blur" },
        ],
        investment: [
          { required: true, message: "请输入预计研发投入", trigger: "blur" },
        ],
      },
    };
  },

  created() {
    // this.join();
    this.getToken();
    console.log("localStorage.getItem('token')", localStorage.getItem("token"));
    this.login();

    // this.getTokeNew();
  },



  methods: {
    // iframe 高度变化回调
    onIframeHeightChanged(height) {
      // console.log('iframe 高度已调整为:', height);
    },


    //重新查看
    refreshPage() {
      window.location.reload();
    },
    //下载
    downWorld() {
      window.open(this.showDownUrl);
    },
    getTokeNew() {
      getToken().then((response) => {
        // console.log("e", response.data);
        this.token = response.data;
      });
    },

    join() {
      let that = this;
      const wsuri = this.url;
      this.ws = new WebSocket(wsuri);
      const self = this;
      this.ws.onopen = function (event) {
        self.text_content = self.text_content + "已经打开连接!" + "\n";
      };
      this.ws.onmessage = function (event) {
        console.log("event.data", event);
        if (self.output === "正在评估,请稍等........") {
          self.output = "";
        }
        if (JSON.parse(event.data).content) {
          self.output += JSON.parse(event.data).content;
        }
        if (JSON.parse(event.data).progress) {
          let msg = JSON.parse(event.data).progress;
          if (msg == 100) {
            console.log("完成", this.showDown);
            that.showDown = true;
            that.showDownUrl = JSON.parse(event.data).downloadUrl;
          }
        }

        // .replaceAll("^\\{|\\}$", "")
        // .replace("{", "")
        // .replace("}", "")
        // .replace('"', "");
      };
      this.ws.onclose = function (event) {
        self.text_content = self.text_content + "已经关闭连接!";
      };
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer;
        container.scrollTop = container.scrollHeight;
      });
    },

    exit() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 验证通过，执行提交逻辑
          // console.log("表单验证通过", this.sizeForm);
          this.send();
        } else {
          // 验证失败
          // console.log("表单验证失败");
          return false;
        }
      });
    },
    send() {
      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      } else {
        this.message = "" +
            "请以科技成果概念验证中心视角，对"+ this.sizeForm.achievementName +
            "技术进行商业化评估，生成HTML格式分析报告，内容需包含以下模块:"+
            "一、技术核心信息"+
            "技术名称："+ this.sizeForm.achievementName +
            "核心原理："+ this.sizeForm.coreTechnology +
            "突破点："+ this.sizeForm.breakthrough  +
            "解决痛点："+ this.sizeForm.solve +
            "研发投入："+ this.sizeForm.investment +
            "二、评估维度分析\n" +
            "技术创新性\n" +
            "对比分析：当前市场同类技术/替代方案对比表\n" +
            "差异化优势：用雷达图展示技术参数对比（如效率/成本/精度）\n" +
            "技术可行性\n" +
            "科学原理验证：原理示意图（SVG绘制）\n" +
            "技术成熟度：TRL等级评估（1-9级）\n" +
            "实验数据：关键指标折线图（如3次迭代测试结果）\n" +
            "商业潜力\n" +
            "市场需求：目标市场规模柱状图（近5年数据）\n" +
            "客户画像：潜在客户行业分布饼图\n" +
            "支付意愿：调研数据百分比堆叠图\n" +
            "实施风险\n" +
            "风险矩阵图：概率/影响双维度评估\n" +
            "关键风险点：研发投入超支预警线图示\n" +
            "财务分析\n" +
            "成本结构：研发/生产/营销占比环形图\n" +
            "收益预测：3年ROI折线预测图\n" +
            "盈亏平衡点：销量-成本交叉分析图\n" +
            "创新等级\n" +
            "专利布局：已申请/拟申请专利数量柱状图\n" +
            "技术代际：与行业基准技术参数对比表\n" +
            "知产保护\n" +
            "保护策略：专利组合构建路径图\n" +
            "侵权风险点：高风险领域热力图\n" +
            "转化路径\n" +
            "市场化路线：B2B/B2C等模式对比图\n" +
            "推广渠道：线上线下渠道成本效益分析表\n" +
            "潜在客户：列举5家目标客户（行业+规模）\n" +
            "三、设计规范\n" +
            "页面布局：宽度1200px居中，模块化设计\n" +
            "视觉系统：\n" +
            "主色：#2A5CAA（科技蓝）\n" +
            "辅助色：#4CAF50（成长绿）\n" +
            "图表规范：\n" +
            "所有图表宽度≤800px，高度≤300px\n" +
            "优先使用SVG矢量图\n" +
            "关键数据加粗变色（如<span style=\"color:#E63946;\">85%</span>）\n" +
            "四、交付要求\n" +
            "文字尽量多一些，内容丰富一些"+
            "图片可以减少一些"+
            "完整HTML文件（无外部资源链接），内容不需要非常多，结尾必须要有html的结束标志，尽量图文并茂，\n" +
            "如果没有数据支撑可以不需要生成图"+
            "宽度1200px居中，主题色#2A5CAA" +
            "图表高度≤300px，优先SVG" +
            "仅使用原生SVG/Canvas/D3.js（基础版）绘制图表（禁止使用ECharts/Chart.js等第三方库）"+
            "关键数据加粗变色"

        // "开发一种 " +
        // this.sizeForm.achievementName +
        // "，核心技术原理是" +
        // this.sizeForm.coreTechnology + "。" +
        // "技术突破点在于" +
        // this.sizeForm.breakthrough + "。" +
        // "主要解决" +
        // this.sizeForm.solve +
        // "。预计研发投入" +
        // this.sizeForm.investment +
        // "万元。" +
        // "请根据以上信息，作为一家科技成果概念验证中心，判断该技术能否转化为大规模生产，从以下角度分别进行评估给出报告：\n" +
        //   "1、技术创新性：目前市面上是否有此类技术或者相似的技术。\n" +
        //   "2、技术可行性：科学原理合理性、技术成熟度(TRL)、实验数据支持。\n" +
        //   "3、商业潜力：市场需求调研、行业规模、替代品分析、客户支付意愿。\n" +
        //   "4、实施风险：研发投入、法律合规性、供应链依赖、技术转化难度。5、财务性分析：基于整体成本、产品收益、风险数据，判断项目是否具备投资收益价值 。\n" +
        //   "6、创新等级：专利地位、技术代际差、颠覆性指数。\n" +
        //   "7、知产保护：协助申请专利等，构建知识产权保护体系，防范侵权风险。\n" +
        //   "8、转化路径：确定最有效的市场化路径和推广渠道，结合成本数据与市场渠道，优化定价策略与推广方案，最好能列举出多个潜在客户名称。\n" +
        //   "按照以上内容生成报告，要求返回html格式，内容丰富生动，有数据部分适当用柱状图或折线图等简单图表，注意图表高度、宽度要适应网页大小，高度不超过500px, 宽度1200居中，没数据的就不用图表。交付：提供完整HTML文件,不需要注释。";

        // console.log("message", this.message);
        this.isLoading = true;
        getHtml({ concat: this.message.replaceAll("%", "") }).then((res) => {
          console.log("res", res);
          if (res.code == 200) {
            this.htmlUrl = res.data;
          } else {
            this.$message({
              message: '请求失败',
              type: "error",
            });
          }
          this.isLoading = false;
          this.textShow = true;
        });
      }
    },
    //原来ws的发送
    // send() {
    //   const token = localStorage.getItem("token");
    //   if (token == null) {
    //     this.$message({
    //       message: "您当前未登录账号，请登录或注册账号后进行查询",
    //       type: "error",
    //       duration: 5000,
    //       showClose: true,
    //       offset: 200,
    //     });
    //   } else {
    //     if (this.ws) {
    //       this.message =
    //         "开发一种 " +
    //         this.sizeForm.achievementName +
    //         "，核心技术原理是" +
    //         this.sizeForm.coreTechnology +
    //         "技术突破点在于" +
    //         this.sizeForm.breakthrough +
    //         "主要解决" +
    //         this.sizeForm.solve +
    //         "预计研发投入" +
    //         this.sizeForm.investment +
    //         "万元，" +
    //         "请根据以上信息，作为一家科技成果概念验证中心，从以下角度分别进行评估给出报告：1、技术可行性：科学原理合理性、技术成熟度(TRL)、实验数据支持。2、商业潜力：市场需求调研、行业规模、替代品分析、客户支付意愿。3、实施风险：研发投入、法律合规性、供应链依赖、技术转化难度。4、财务性分析：基于整体成本、产品收益、风险数据，判断项目是否具备投资价值 。 5、创新等级：专利地位、技术代际差、颠覆性指数。6、知产保护：协助申请专利等，构建知识产权保护体系，防范侵权风险。7、转化路径：确定最有效的市场化路径和推广渠道，结合成本数据与市场渠道，优化定价策略与推广方案。要求格式工整";
    //       console.log("message", this.message);
    //       let params = {
    //         mode: "document",
    //         content: this.message,
    //         achievement_name: this.sizeForm.achievementName,
    //       };
    //       this.ws.send(JSON.stringify(params));
    //       this.textShow = true;
    //       this.output = "正在评估,请稍等........";
    //     } else {
    //       alert("未连接到服务器");
    //     }
    //   }
    // },

    loadReportData(data) {
      this.rawReportHtml = data;
      // 提取body内容传给子组件
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      console.log("doc", doc);
      this.reportHtml = doc.body.innerHTML;
    },
    //登录接口
    login() {
      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      }
    },

    hisShowChange() {
      this.hisShow = false;
    },
    myInformation() {
      this.hisShowChange();
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      getConceptList(params).then((response) => {
        console.log("response", response);
        if (response.code == 200) {
          this.tableData = response.rows;
          this.total = response.total; // 更新总条数
          if (response.rows.length == 0) {
            this.showEmpty = true; // 如果没有数据，显示空数据提示
          } else {
            this.showEmpty = false; // 有数据则不显示空数据提示
          }
        } else {
          this.$message({
            message: response.msg,
            type: "error",
            duration: 5000,
            showClose: true,
            offset: 200,
          });
        }
      });
    },
    changePage(ele) {
      console.log("ele", ele);
      this.pageNum = ele;
      this.myInformation();
    },
    handleDown(row) {
      console.log("row", row);
      this.showDownUrl = row.reportPath;
      // 使用浏览器的下载功能
      const link = document.createElement("a");
      link.href = row.reportPath;
      link.download = "评估报告.pdf"; // 设置下载文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    //跳转登录
    loginUp() {
      this.$router.push({ path: "/login", query: { type: "6" } });
    },

    logout() {
      console.log("go");
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = true;
      this.$router.push({ path: "/login", query: { type: "6" } });
      // var item = sessionStorage.getItem("token");
    },
    getToken() {
      if (localStorage.getItem("token")) {
        this.loginTrue = true;
        this.showPage = true;
      } else {
        this.loginTrue = false;
        // this.$router.push('/login')
      }
    },

    // iframe 相关方法
    // openIframe(url) {
    //   this.iframeUrl = url || this.iframeUrl;
    //   this.showIframe = true;
    // },

    // closeIframe() {
    //   this.showIframe = false;
    // },

    // 示例：在评估完成后显示iframe
    // showIframeAfterEvaluation() {
    //   // 可以根据需要设置不同的URL
    //   this.openIframe("https://www.example.com");
    // },
  },
};
</script>

<style scoped lang="scss">
.fade-in {
  animation: fadeIn 0.8s ease-in-out forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.loadingGif {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.formSelectDiv {
}
#myapp {
  padding-top: 20px;
  // position: relative;
  // width: 80%;
  // margin: 60px auto;
  // background: linear-gradient(
  //   139.72deg,
  //   rgba(255, 255, 255, 1) 0%,
  //   rgba(246, 251, 255, 1) 10.54%,
  //   rgba(255, 255, 255, 1) 79.05%,
  //   rgba(237, 246, 255, 1) 100%
  // );
  // //  box-shadow: 6px 6px 2px rgba(0, 0, 0, 0.1);
  // box-shadow: 1em 1em 1em #d8dae0b1, -0.75em -0.75em 1em #ffffff;
  // border: 1.5px solid #eceffb;
  // min-height: 100px;
  // padding: 40px;

  .spanFront {
    font-size: 20px;
    margin-bottom: 20px;
    text-align: left;
  }
  border-radius: 20px;
  .btnBox {
    // width: 90%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    button {
      cursor: pointer;
      margin: 0 20px;
      width: 150px;
      height: 40px;
      font-size: 20px;
      border-radius: 8px;
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
    }
  }
}
:deep(.el-input-group__append) {
  background-color: #fff;
  border: none;
  color: #606266;
  font-size: 20px;
}
:deep(.el-form-item__label) {
  padding: 0;
}
:deep(.el-input__inner),
:deep(.el-textarea__inner) {
  border: none;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0;
  font-size: 20px;
}
:deep(.el-input__inner) {
  padding-bottom: 10px;
  height: 40px !important;
}
:deep(.el-textarea__inner) {
  padding-top: 0;
}

.classLabe2 {
  display: flex;

  .labe2Right {
    margin-left: 270px;
  }
}

.form-row {
  width: 800px;
  margin: 40px auto 0;
  .formClass {
    font-size: 20px;

    .InputNumberClass {
      width: 80%;
    }
  }
}

::v-deep .el-form-item__label {
  font-size: 20px;
}

::v-deep .el-input__inner {
  font-size: 20px;
}

::v-deep .bold-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px !important;
}

//加载中
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 遮罩层在最上面 */
}

.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #0077ff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

/* 加载动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载文本样式 */
.loading-text {
  color: #ffffff;
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
}

//数据处理样式
.content {
  white-space: pre-line; /* 保留换行符 */
  text-align: left;
  font-size: 20px;
  line-height: 1.8;
}

::v-deep .refreshPageClass {
  font-size: 20px;
  margin-top: 30px;
  border-radius: 10px;
  width: 200px;
  height: 40px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.queryButton {
  width: 200px;
  font-size: 20px;
  margin-top: 30px;
}

//.form-row {
//  display: flex;
//  align-items: center;
//  width: 80%;
//}

//.form-row span {
//  margin-right: 10px;
//  width: 20%;
//}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
  font-size: 20px;
}

.selectedForm {
  width: 200px;
}

.formSelectDiv {
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.label {
  margin-right: 10px; /* 控制文本和选择框之间的间距 */
}

.selectClass {
  padding: 5px;
  border: 1px solid #ccc;
  width: 500px;
  font-size: 20px;
}

.bord {
  margin: 90px auto 120px;
  padding: 20px;
  max-width: 1200px;
  min-height: 300px;
  height: auto;
  border: 2px solid #ffffff; /* 边框 */
  text-align: center;
  transition: all 0.3s ease; /* 平滑过渡 */
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .spanFront {
    margin-bottom: 20px;
    font-size: 20px;
    text-align: center;
  }

  .formSelect {
    font-size: 20px !important;
  }
}

.bord:hover {
  //transform: translateY(-10px); /* 向上浮起 */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* 添加阴影，增强浮起效果 */
}

::v-deep .subClass {
  color: #fff !important;
  background-color: #0077ff !important;
}

.closeClass {
  color: #fff;
  background-color: #ff4d4f;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clickable {
  color: #0077ff;
  cursor: pointer;
  //text-decoration: underline;
}

.bannerBox {
  width: 100%;
}

.layout {
  width: 100%;
}

::v-deep .layout {
  display: flex;
}

.banner_box {
  height: 500px;
}

.banner_box .ban_top .right .no_login {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.banner_box .ban_top .left img {
  width: 176px;
}

.img {
  max-width: 100%;
  border: none;
}

.banner_box .ban_top .left .div2 {
  position: relative;
  margin: 0 40px 0 80px;
  padding: 12px 20px;
  border-radius: 23px;
}

.banner_box {
  background-image: url("~@/assets/img/gainian.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 24px 0 190px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-around;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.banner_box .ban_text {
  margin: 100px 0 43px;
  font-weight: 600;
  font-size: 54px;
  color: #fff;
  line-height: 71px;
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
  flex: none;
}

.banner_box .btn1,
.banner_box .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.ban_btn {
  margin-top: 410px;
  .btn1 {
    position: absolute;
    left: 380px;
  }
}

.banner_box .ban_btn .btn1 {
  border-radius: 30px;
  border: 2px solid #fff;
  color: #fff;
}

.banner_box .ban_btn .btn2 {
  border-radius: 30px;
  background: #fff;
  color: #333;
}

.banner_box .ban_btn .btn1,
.banner_box .ban_btn .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.banner_box .ban_btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box .step,
.step_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box {
  background: #f7f7f7;
  padding: 90px 0 100px;
}

.step_box .step .step_top {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
}

.step_box .step .step_lab {
  margin-top: 26px;
  font-weight: 400;
  font-size: 20px;
  color: #606266;
  line-height: 27px;
}

.step_box .step .step_itm {
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.page_width {
  width: 1200px;
  margin-top: 100px;
}

.step_box .step {
  flex-direction: column;
}

.step_box .step .step_itm .itm_box .num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #2238c2;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 2px solid #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 27px;
  width: 15%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 40px;
  width: 10%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit span {
  color: #2238c2;
}

.reason_box .reason .cont .cont_itm {
  margin-left: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 385px;
  height: 286px;
  padding: 62px 53px 0;
  box-sizing: border-box;
  background: #f5fbfc;
  border-radius: 12px;
  font-size: 16px;
}

.cont_itmDun {
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exchange_box .exchange .ex_left .tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  margin-bottom: 50px;
}

.exchange_box .exchange .ex_left .tit span {
  color: #2238c2;
}

.exchange_box .exchange .ex_left {
  width: 75%;
}

.exchange_box .exchange .ex_left .itm img {
  width: 24px;
  height: 24px;
  margin-right: 14px;
  font-size: 16px;
}

img {
  max-width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange .ex_left .itm {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  font-size: 16px;
}

.exchange_box {
  padding: 84px 0 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/img/lineImg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

img {
  width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.website {
  padding: 30px 0;
  background: #252525;
  justify-content: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
  color: #a8a8a8;
  background: #252525;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
  line-height: 1.6;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.logo {
  cursor: pointer;
  background-image: url("~@/assets/img/logn.png");
  background-size: 450px 70px;
  width: 450px;
  height: 70px;
  margin-bottom: 25px;
}

.problem_box {
  width: 100%;
  background: #fff;
  padding: 90px 0 131px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.problem_box_inline {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 131px;
}

.problem_box_inline .pro_tit span {
  color: #009eb8;
}

.problem_box_inline .pro_tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
  text-align: center;
  margin-bottom: 80px;
}

.problem_box_inline .pro_lab {
  font-weight: 700;
  margin-bottom: 13px;
  font-size: 20px;
  color: #333;
}

.problem_box_inline .pro_cont {
  font-weight: 400;
  font-size: 16px;
  color: #666;
  line-height: 28px;
}

.mb40 {
  margin-bottom: 40px;
}

.form-container {
  max-width: 1200px;
  margin: 90px auto 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.steps {
  display: flex;
  justify-content: space-between;

  position: relative;
  padding: 0 40px;
  margin-top: 30px;
  margin-bottom: 60px;
}

.step {
  display: flex;
  align-items: center;
  z-index: 1;
}

.step-number {
  width: 24px;
  height: 24px;
  background: #1890ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 14px;
}

.step-text {
  font-size: 20px;
}

.step::after {
  content: "";
  display: inline-block;
  width: 127px;
  height: 1px;
  z-index: 0;
  margin-left: 6px;
}

.steps .step:last-child:after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  background: #e8e8e8;
  z-index: 0;
  margin-left: 0;
}

.form-row {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 20px;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.form-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 20px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
}

.file-upload {
  border: 1px dashed #d9d9d9;
  padding: 20px;
  text-align: center;
  background: #fafafa;
  border-radius: 4px;
}

.upload-button {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.file-info {
  font-size: 20px;
  color: #666;
  margin-top: 12px;
}

.file-types {
  font-size: 20px;
  color: #666;
  margin-top: 8px;
}

.form-containerquery {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.file-types {
  font-size: 20px;
  color: #666;
  margin-bottom: 20px;
}

.certificate-type {
  border: 1px solid #e8e8e8;
  padding: 15px;
  margin-bottom: 20px;
}

.certificate-warning {
  color: #ff4d4f;
  font-size: 12px;
  margin-bottom: 10px;
}

.certificate-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.certificate-option {
  border: 1px solid #e8e8e8;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}

.certificate-option:hover {
  border-color: #40a9ff;
}

.certificate-option.selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
}

.certificate-option img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.rights-section {
  margin-bottom: 20px;
}

.rights-grid {
  width: 90%;
  margin: 0 auto;

  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.right-option {
  width: 25%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  label {
    color: #333;
  }
}

.agreement {
  display: flex;
  align-items: center;

  margin-bottom: 20px;
  justify-content: center;

  input {
    width: 16px;
    height: 16px;
  }
}

.agreement a {
  color: #1890ff;
  text-decoration: none;
}

.submit-buttonLeft {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 25%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-buttonRight {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 10%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-button {
}

.submit-button:hover {
  background: #40a9ff;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.cha_xun {
  padding: 3.5rem 18.33rem 10.42rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tips {
    font-size: 1.33rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #232323;
    line-height: 2.25rem;
  }
}

.cha_xun .tips {
  margin-top: 2.08rem;
  padding: 0.92rem 1.92rem 3.25rem;
  background: rgba(39, 130, 255, 0.1);
  border: 1px solid #2782ff;
  border-radius: 0.25rem;
  display: flex;
  align-items: baseline;
}

.cha_xun .tips div[data-v-71571416] {
  font-size: 1.33rem;
  font-weight: 400;
  color: #232323;
  line-height: 2.25rem;
  font-size: 20px;
}

.cha_xun .input_box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cha_xun .file_hash[data-v-71571416],
.cha_xun .unified_numbering[data-v-71571416] {
  display: flex;
  align-items: center;
  margin-top: 4.25rem;
}

.cha_xun .file_hash .el-input[data-v-71571416] .el-input__inner,
.cha_xun .unified_numbering .el-input[data-v-71571416] .el-input__inner {
  border-radius: 0.25rem;
  font-size: 1.4rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.cha_xun .query[data-v-71571416] {
  cursor: pointer;
  margin-top: 5.67rem;
  padding: 1.17rem 10rem;
  display: inline-block;
  background: #2782ff;
  box-shadow: 0 0.3rem 3rem 0 rgba(29, 62, 187, 0.2);
  border-radius: 0.25rem;
  font-size: 1.67rem;
  font-weight: 700;
  color: #fff;
  line-height: 2rem;
}

.me {
  max-width: 1200px;
  height: auto;
  margin: 90px auto 90px;
  padding: 20px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .labe2 {
  font-size: 16px;
}

.no_loginLeft {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.no_loginRight {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
  margin-left: 10px;
}

.el-dropdownClass {
  width: 50%;
}

.dataclass {
  font-size: 20px;
}

.submitClass {
  display: flex;
}

.el-textarea .el-input__count {
  margin-bottom: 10px !important;
}

.right-optionValue {
  width: 30%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}

/* iframe 样式 */
.concept-iframe {
  margin: 20px 0;
}

/* .iframe-container {
  margin-top: 30px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.iframe-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #f5f5f5;
  border-bottom: 1px solid #e8e8e8;
}

.iframe-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-iframe {
  background: #ff4d4f;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.close-iframe:hover {
  background: #ff7875;
}

.embedded-iframe {
  width: 100%;
  height: 500px;
  border: none;
} */
</style>
